import React from 'react';
import { Control, Errors } from 'react-redux-form';
import MaskedInput, { conformToMask } from 'react-text-mask';

import withHint from './withHint';
import arrow from '../../../assets/images/select-arrow.svg';
import './styles.css';

// MaskedInput needs the defaultValue to generate the masked value,
//  but passing that along to the input as the defaultValue prevents
//  editing the input field when used with react-redux-form.
const CustomMask = props => (
  <MaskedInput
    {...props}
    render={
      (ref, inputProps) => {
      const {
        defaultValue,
        ...renderProps
      } = inputProps;
      return (<input
        ref={ref}
        {...renderProps}
        onKeyDown={(e) => {
          // Handle onKeyDown to fix issue with backspace not deleting mask characters
          //  react-text-mask 5.4.3 claimed to fix this, but updating from 5.4.2 did not
          //  solve the problem.
          // react-text-mask also deletes onChange and mask from the props passed to
          //  a custom render method, so get them from the original props passed to
          //  CustomMask
          const { onChange } = props;
          const start = Number(e.target.selectionStart);
          const end = Number(e.target.selectionEnd);
          const keyCode = Number(e.keyCode);

          if (keyCode === 8) {
            e.preventDefault();
            let newValue = e.target.value;
            newValue = `${newValue.substring(0, start - 1)}${newValue.substring(start === end ? start : end, e.target.value.length)}`;
            newValue = newValue.replace(/\D+/g, '');
            e.target.value = conformToMask(newValue, props.mask, { guide: false }).conformedValue;
            e.target.selectionStart = start - 1;
            e.target.selectionEnd = start - 1;
            if (onChange) onChange(e);
          }
        }}
      />);
    }}
  />);


const EditableField = (props) => {
  let options = [];
  switch (props.inputType) {
    case 'text':
      if (props.mask) {
        return (
          <Control
            component={CustomMask}
            styleName="accountControl"
            {...props}
          />
        );
      }
      return (
        <Control.text
          styleName="accountControl"
          {...props}
        />
      );
    case 'select':
      if (Array.isArray(props.options)) {
        options = props.options.map(([key, val]) => (
          <option key={key} value={key}>
            {val}
          </option>
        ));
      } else {
        options = Object.keys(props.options).map(k => (
          <option key={k} value={k}>
            {props.options[k]}
          </option>
        ));
      }

      return (
        <div styleName="accountControl">
          <Control.select
            styleName="accountRowSelect"
            {...props}
          >
            { options }
          </Control.select>
          <img
            styleName="filterArrow"
            src={arrow}
            alt="arrow"
          />
        </div>
      );
    default:
      return null;
  }
};

const DisplayField = (props) => {
  const {
    display,
    defaultValue,
    mask,
  } = props;
  return mask ? (
    <MaskedInput
      styleName="staticField"
      readonly
      {...props}
    />
  ) : (
    <div styleName="staticField">
      { display || defaultValue }
    </div>
  );
};

const Component = (props) => {
  const {
    editMode,
    label,
    hint,
  } = props;
  let value;
  if (editMode === 'editting') {
    if (hint) {
      value = withHint(EditableField, hint)(props);
    } else {
      value = (<EditableField {...props} />);
    }
  } else {
    value = (<DisplayField {...props} />);
  }

  return (
    <div styleName="accountInfo">
      <div styleName="fieldRow">
        <div styleName="fieldLabel">{label}</div>
        { value }
      </div>
      { editMode === 'editting' &&
        <Errors
          styleName="errorText"
          show={field => field.touched || field.submitted}
          model={props.model}
          {...props.errorHandler}
        />
      }
    </div>
  );
};

Component.displayName = 'AccountInputRow';

export default Component;



// WEBPACK FOOTER //
// ./src/components/Forms/Controls/AccountInputRow.js